import { render, staticRenderFns } from "./OrderInfomation.vue?vue&type=template&id=44472a81&scoped=true"
import script from "./OrderInfomation.vue?vue&type=script&lang=js"
export * from "./OrderInfomation.vue?vue&type=script&lang=js"
import style0 from "./OrderInfomation.vue?vue&type=style&index=0&id=44472a81&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44472a81",
  null
  
)

export default component.exports